/* aaa-scroll-restore: keep the desktop scroll position across a reload.
 *
 * From 990px up stock Horizon locks html/body to 100dvh and makes
 * .page-wrapper the scroller. Browsers only restore the viewport's
 * position, so Horizon's scroll-container.js sets
 * history.scrollRestoration = "manual" and does its own: it writes the
 * wrapper's scrollTop into history.state on `pagehide` and scrolls back
 * to it on `pageshow`. On a reload that save is lost - Chrome has already
 * committed the history entry when `pagehide` runs, so the replaceState
 * made there is discarded and the page opens at the top.
 *
 * Fix: keep history.state.scrollTop current while the user scrolls
 * (debounced), so the value is already on the entry when the reload
 * starts. Horizon's own `pageshow` handler then restores it. Below 990px
 * the root scrolls, native restoration is on, and the wrapper never
 * fires scroll events, so this is a no-op there.
 */
(() => {
  const wrapper = document.querySelector('.page-wrapper');
  if (!wrapper) return;

  const desktop = window.matchMedia('(min-width: 990px)');
  let timer = 0;

  const save = () => {
    timer = 0;
    if (!desktop.matches) return;
    try {
      const state = history.state && typeof history.state === 'object' ? history.state : {};
      history.replaceState({ ...state, scrollTop: wrapper.scrollTop }, '');
    } catch (e) {
      /* history API throttled - the next scroll retries */
    }
  };

  wrapper.addEventListener(
    'scroll',
    () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(save, 150);
    },
    { passive: true }
  );
})();
